import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import Footer from '@/app/components/Header/Footer';

import Header from '@/app/components/Header/Header';
import NavBar from '@/app/components/Header/NavBar';
import TherigyErrorBoundary from '../errors/TherigyErrorBoundary';
import { useLocation } from 'react-router-dom';

const propTypes = {
    children: PropTypes.node.isRequired,
};

const WithHeader = (props) => {
    const { children } = props;

    const { pathname } = useLocation();
    const wrapperRef = useRef(null);

    /**
     * Scroll top when route changes.
     */
    useEffect(() => {
        if (wrapperRef.current) {
            wrapperRef.current.scrollTop = 0;
        }
    }, [pathname]);

    return (
        <div className="page-container" data-testid="with-header">
            <Header />
            <NavBar />
            <div className="content-wrap" ref={wrapperRef}>
                <TherigyErrorBoundary>{children}</TherigyErrorBoundary>
            </div>
            <div className="footer">
                <Footer />
            </div>
        </div>
    );
};

WithHeader.propTypes = propTypes;

export default WithHeader;
